import notifications from './notifications';
import viewNotifications from './viewNotifications';
import desktopNotifications from './desktopNotifications';
import notificationData from './notificationData';
import currentNotification from './currentNotification';

import invites from './invites';

import broadcasts from './broadcasts';

export default {
	// namespaced: true,
	modules: {
		notifications, viewNotifications, desktopNotifications, notificationData, currentNotification,
    invites,
    broadcasts
	}
}
